var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"action-rounded",class:[{ 'white-background': _vm.backgroundWhite }, _vm.size],attrs:{"title":_vm.name}},[_c('i',{class:_vm.setIconClass})])
}
var staticRenderFns = []

export { render, staticRenderFns }